import { useT } from "@/i18n";

const ITEMS = ["LAMINA · lamellare BSH", "TRAMA · X-LAM", "ARCO · lamellare curvo", "PIANO · solai", "MASSELLO · legno massiccio", "DOGA · perline", "BRACE · biomassa", "SCIROCCO · trucioli", "NODO · carpenteria"];

const Row = () => {
  const tr = useT();
  return (
  <div className="flex shrink-0 items-center gap-10 pr-10">
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center gap-10">
        <span className="whitespace-nowrap font-serif text-4xl italic sm:text-6xl">{tr(`marquee.${i}`, t)}</span>
        <span className="h-4 w-4 shrink-0 bg-[#7DB33A]" />
      </span>
    ))}
  </div>
  );
};

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[#121110]/10 bg-[#F7F5F0] py-8 text-[#121110]" data-testid="editorial-marquee" aria-label="I nostri ambiti">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
